export default "__VITE_ASSET__DGiptbwh__"